import { BrowserDocument } from './document';
import { WindowService } from '../../service/window/service';

export function BrowserDocumentFactory(): BrowserDocument {
  const windowService = WindowService();

  return new BrowserDocument(windowService.getNative().document);
}
